/**
 * What to log about a failed request, without the request itself.
 *
 * A request error logged whole goes to Sentry Logs with its body, minus
 * secret-named fields, when it came through the shared API client
 * (`loggable-request-error.ts`, NG-2189). The auth and account forms log this
 * summary instead: their bodies are nearly all password and email, and the
 * status, the API's error code and the message say why the request failed
 * whichever path it took.
 */
export function requestErrorSummary(error: unknown): {
  status?: number;
  code?: string;
  message: string;
} {
  const response = (error as { response?: { status?: number; data?: { code?: unknown } } })
    ?.response;
  const code = typeof response?.data?.code === "string" ? response.data.code : undefined;
  return {
    status: response?.status,
    ...(code ? { code } : {}),
    message: error instanceof Error ? error.message : String(error),
  };
}
